import { render, staticRenderFns } from "./OrganizationTreeSelect.vue?vue&type=template&id=5e3b8b76"
import script from "./OrganizationTreeSelect.vue?vue&type=script&lang=js"
export * from "./OrganizationTreeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports